module.exports = __webpack_public_path__ + "img/14.d21e0341.png";